export class VehicleAttributeModel {
    public vehicleAttributeHashId: string;
    public attributeName: string;
    public attributeDesc: string;
    public vehicleAttributeCategoryHashId: string = '';
    public instanceHashId: string = '';
    public vehicleAttributeCategoryName: string;
    public instanceName:string;
    public isChecked: boolean;
    public isEditable:boolean;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vehicle-attribute/models/vehicleattribute.model.ts